import { render } from "./DigitInputControl.vue?vue&type=template&id=5d69484b&scoped=true"
import script from "./DigitInputControl.vue?vue&type=script&lang=js"
export * from "./DigitInputControl.vue?vue&type=script&lang=js"

import "./DigitInputControl.vue?vue&type=style&index=0&id=5d69484b&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d69484b"]])

export default __exports__